<template>
  <div class="user">
    <div class="photo">
      <v-gravatar v-if="!!user.email" :email="user.email" :size="34" />
    </div>
    <div class="info">
      <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
           <span>
             {{ this.user.email }}
             <!-- <b class="caret"></b> -->
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <li>
              <a href="javascript:void(0)">
                <span class="sidebar-mini">Mp</span>
                <span class="sidebar-normal">My Profile</span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <span class="sidebar-mini">Ep</span>
                <span class="sidebar-normal">Edit Profile</span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <span class="sidebar-mini">S</span>
                <span class="sidebar-normal">Settings</span>
              </a>
            </li>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  import store from '@/store'
  import firebase from 'firebase'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data () {
      return {
        isClosed: true,
        user: {}
      }
    },
    methods: {
      init () {
        this.user = firebase.auth().currentUser
      },
      toggleMenu () {
        this.$router.replace({ name: 'Account' })
        // this.isClosed = !this.isClosed
      }
    },
    mounted: function () {
      this.$nextTick(() => {
        this.init()
      })
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue